module.exports = __webpack_public_path__ + "img/videoImg.4cfc2350.png";